<header class="mobile-app-header" *ngIf="visible">
  <button
    *ngIf="showBackButton"
    mat-icon-button
    class="mobile-header-action"
    type="button"
    aria-label="Go back"
    (click)="goBack()"
  >
    <mat-icon>arrow_back</mat-icon>
  </button>

  <a class="mobile-brand" routerLink="/projects" aria-label="CHEF home">
    <mat-icon class="mobile-brand-logo" [svgIcon]="'chefLogo'"></mat-icon>
    <!-- <span class="mobile-brand-name">CHEF</span> -->
  </a>

  <h1 class="mobile-page-title">{{ pageTitle }}</h1>

  <span class="mobile-header-spacer" aria-hidden="true"></span>
</header>
